export default {
    headerLabel: 'Find companies',
    companyListLabel: 'Companies',
};
